import {
  Datagrid,
  DateField,
  EditButton,
  FunctionField,
  List,
  TextField,
} from 'react-admin';
import { useRegion } from '../auth/RegionContext';
import { RequireAccess } from '../auth/RequireAccess';
import type { EmailTemplate } from '../dataProvider';
import { templateLabel } from './emailTemplatesModel';

/**
 * Email templates list (D-settings-s3-email-templates, Phase 9 S3). The fixed
 * transactional set, ONE ROW PER (templateKey, market), EDIT-ONLY: no create, no
 * delete (a template key is a backend SES sender contract). Region-scoped by the
 * access SCOPE through the one marketsForScope mapping (a uk editor sees uk rows).
 * Gated email_templates:write (a config surface, not a read-only view; a viewer's
 * '*:read' does not surface it).
 */

/** The list itself. Exported for testing without the access wrapper. */
export const EmailTemplateListView = () => {
  const { region } = useRegion();
  return (
    <List
      resource="emailTemplates"
      title="Email templates"
      // Scope, not activeRegion: GLOBAL shows both markets (marketsForScope).
      filter={{ region }}
      sort={{ field: 'templateKey', order: 'ASC' }}
      perPage={50}
      exporter={false}
    >
      {/* Edit-only: no row navigation, no bulk actions (no bulk delete), no create.
          Edit is a per-row link, the fixed-set-edit pattern (S2 networks). */}
      <Datagrid rowClick={false} bulkActionButtons={false}>
        <FunctionField
          label="Template"
          render={(r: EmailTemplate) => templateLabel(r.templateKey)}
        />
        <FunctionField
          label="Market"
          render={(r: EmailTemplate) => String(r.market).toUpperCase()}
        />
        <TextField source="subject" label="Subject" />
        <DateField source="updatedAt" label="Updated" />
        <EditButton />
      </Datagrid>
    </List>
  );
};

/** Gated entry point registered as the emailTemplates Resource's list. */
export const EmailTemplateList = () => (
  <RequireAccess capability="email_templates:write">
    <EmailTemplateListView />
  </RequireAccess>
);
